<template>
  <div class="shell">
    <div class="policy">
      <div class="policyTitle">
        <div class="title-name">
          电子保单/批单
        </div>
      </div>
      <div v-if="ePolicyDtoList.length !== 0" class="policyBody">
        <p v-for="(item, i) in ePolicyDtoList" :key="i" class="policy-clause" @click="details(item)">
          {{ item.downLoadName }}
        </p>
      </div>
      <div v-if="policyTitle" class="policyBody">
        <p class="policy-clause">
          暂无订单
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api/api.js'
import checkFormat from '@/utils/checkFormat.js'
export default {
  data() {
    return {
      orderId: this.$route.query.orderId || '',
      ePolicyDtoList: [], // pdf地址数据
      policyTitle: false
    }
  },
  created() {
    // this.getORderetails()
  },
  mounted: function() {
    // console.log(this.$route.query)
    this.getORderetails()
  },
  methods: {
    getORderetails() { // 根据url传参的订单号和订单ID获取订单详情 '&fileContentFlag=0'是否返回文件流
      if (this.orderId) {
        this.$http.post(api.queryOrderDetail + '?orderId=' + this.orderId + '&fileContentFlag=0')
          .then(res => {
            // 获取的可以预览的pdf数据
            if (res.data.resultObj.ePolicyDtoList && res.data.resultObj.ePolicyDtoList.length) {
              this.ePolicyDtoList = res.data.resultObj.ePolicyDtoList
            } else {
              this.policyTitle = true
            }
          })
      } else {
        this.policyTitle = true
      }
    },
    details(item) {
      if (checkFormat.checkEnv() == 'APP') {
        previewPDF.postMessage(api.projectHostUrl + item.downLoad)
      } else {
        window.open(api.projectHostUrl + item.downLoad)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
[v-cloak] {
    display: none;
}
* {
    margin: 0;
    font-size: 0.14rem;
    padding: 0;
}
.shell{
    font-size: .14rem;
    padding: .1rem;
    background-color: #f7f6f9;
    .policy{
        overflow: hidden;
        padding: 0.2rem;
        background-color: #fff;
        border-radius:0.1rem ;
        .policyTitle{
            .title-name{
                height: 0.22rem;
                font-size: .16rem;
                line-height: .22rem;
                //color: rbga(81, 81, 81, 1);
                font-weight: 600;
                padding: 0.1rem 0;
                color: #333;
            }
        }
        .policyBody{
            .policy-clause{
                    display: block;
                    font-size: .14rem;
                    line-height: .3rem;
                    color: rgba(101, 46, 143, 1);
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    position: relative;
                    border-top: 2px solid #f7f6f9;
                    padding: 0.14rem 0;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/Pdf/Pdf.vue